import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(root)/bridge/page.tsx");
